var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":"white","rounded":"circle","size":_vm.size}},[_c('v-img',{attrs:{"src":require('@/assets/img/logo.png'),"alt":"Merki Bahá’í samfélagsins á Íslandi","max-width":_vm.imgMaxWidth,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }